import React, { FC } from 'react'
import { useSelector } from 'react-redux'
import { usePagination } from '@ucheba/utils/hooks/usePagination'
import { Spacing } from '@ucheba/ui/components/Spacing/desktop'
import { Grid, GridCol } from '@ucheba/ui/components/Grid/desktop'
import { Text } from '@ucheba/ui/components/Text/desktop'
import { Pagination } from '@ucheba/ui/components/Pagination/desktop'
import { eventsSearchLimit } from '@ucheba/store/events/constants'
import { eventsSearchSelectors } from '@ucheba/store/events/search'

const EventsPagePagination: FC = () => {
  const searchResults = useSelector(eventsSearchSelectors.entity)

  const { currentPage, setCurrentPage, totalPages } = usePagination(
    searchResults?.total,
    eventsSearchLimit
  )

  if (!searchResults.items.length) return null

  return (
    <>
      <Spacing spacing='xlarge' />

      <Grid justifyContent='space-between' alignItems='center'>
        <GridCol width='auto'>
          <Text fontWeight='bold'>{`Всего: ${searchResults?.total}`}</Text>
        </GridCol>

        <GridCol width='auto'>
          <Pagination
            totalPages={totalPages}
            currentPage={currentPage}
            changePageHandler={setCurrentPage}
          />
        </GridCol>
      </Grid>
    </>
  )
}

export default EventsPagePagination
